import axios from 'axios';

import SESSION_TOKEN_SERVICE from '@/constants/SessionTokenService';

const API_PREFIX = '/api/v1/';

const API_HOST = process.env.API_BASE_URL_FORM + API_PREFIX;

const APIinstance = axios.create({
	baseURL: `${API_HOST}`,
	withCredentials: false,
	headers: {
		'Content-Type': 'application/json',
	},
});

APIinstance.interceptors.request.use(
	(config) => {
		const accessToken = SESSION_TOKEN_SERVICE.getLocalAccessToken();

		if (accessToken) {
			config.headers['Authorization'] = 'Bearer ' + accessToken;
		}

		return config;
	},
	(error) => {
		return Promise.reject(new Error(error));
	},
);

export default APIinstance;
